<template>
  <v-dialog
    content-class="rounded-xl"
    v-model="dialog_input_element_visible"
    width="400"
  >
    <v-card>
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              icon
              @click="closeInputDialog()"
            >
              <v-icon size="20">
                fa-times
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-flex justify-center text-h5">
            Создание модуля
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <div class="mt-3">
          <v-text-field
            v-model="new_module.name"
            label="Название модуля"
            no-data-text="Данные отсутствуют"
            hide-details
            rounded
            outlined
          ></v-text-field>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          class="mx-auto rounded-xl"
          @click="saveNewNameModule()"
          color="teal"
          outlined
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
    export default {
        name: "DialogInputElements.vue",
        props: {
            dialog_input_element_visible: {
                type: Boolean
            }
        },
        data: () => ({
            new_module: {
                name: ''
            }
        }),
        computed: {},
        methods: {
            closeInputDialog() {
                this.$emit('closeInputDialog', {
                    dialog_input_element_visible: false
                })
            },
            saveNewNameModule(){
                this.$emit('saveNewNameModule', {
                    new_module_name: this.new_module.name
                })
            }
        },
    }
</script>

<style scoped>

</style>